export default class SupplierDescription {

  constructor() {
    $("#sitewide-overlay, #supplier-product-description-dialog .close, #supplier-product-description-dialog .done")
      .on("click", () => $("#supplier-product-description-dialog, #sitewide-overlay").fadeOut())

    this.renderViewMoreLinks()

    this.renderSummaryDescriptionViewMoreLink()
  }

  private renderViewMoreLinks() {
    const supplierTable = document.getElementById("supplier-table");

    // note: first child is the header row, skipping it by starting at index 1
    for (let i = 1; i < supplierTable.children.length; i++) {
      let supplierRowId = supplierTable.children[i].id;
      let needsViewMoreLink = this.isDescriptionTruncated(supplierRowId);

      if (needsViewMoreLink) {
        this.renderViewMoreLink(supplierRowId);
      }
    }
  }

  private renderSummaryDescriptionViewMoreLink() {
    let description = $(".has-description .description:visible");
    let needsViewMoreLink = false;
    try {
      const renderedHeight = $(description)[0].clientHeight;
      const fullHeight = $(description)[0].scrollHeight;
      needsViewMoreLink =  fullHeight > renderedHeight;
    } catch (error) {
      // just rely on false value for needsViewMoreLink
    }

    if (needsViewMoreLink) {
      const viewMoreHtml = "<button class='view-more-link'>View More</button>";
      $(viewMoreHtml).insertAfter($(description));
      $(".product-summary .view-more-link").on("click", function() {
        SupplierDescription.showSupplierDescription("supplier-table-row-1");
      });
    }
  }

  private renderViewMoreLink(supplierRowId: string) {
    const description = $("#" + supplierRowId + " .description-content");
    const viewMoreHtml = "<button class='view-more-link' data-testId='" + supplierRowId + "-view-more'>View More</button>";
    $(viewMoreHtml).insertAfter($(description));
    $("#" + supplierRowId + " .view-more-link").on("click", function() {
      SupplierDescription.showSupplierDescription(supplierRowId);
    });
  }

  private isDescriptionTruncated(supplierRowId: string): boolean {
    const description = $("#" + supplierRowId + " .description-content");
    const renderedHeight = $(description)[0].clientHeight;
    const fullHeight = $(description)[0].scrollHeight;
    return fullHeight > renderedHeight;
  }

  private static populateSupplierDescriptionModal(supplierRowId: string) {
    const supplier = $("#" + supplierRowId);
    const supplierName = $(supplier).find(".supplier-name a").text();
    const productNumber = $(supplier).find(".product-number a").text();
    const fullDescription = $(supplier).find(".description-content-html-for-modal").html();

    const descriptionModal = $("#supplier-product-description-dialog");
    $(descriptionModal).find(".supplier-name").text(supplierName);
    $(descriptionModal).find(".product-number").text(productNumber);
    $(descriptionModal).find(".description").html(fullDescription);
  }

  private static showSupplierDescription(supplierRowId: string) {
    this.populateSupplierDescriptionModal(supplierRowId);
    const scrollTop = ((window.scrollY  !== undefined) ? window.scrollY : document.body.scrollTop) + 25;
    $('#supplier-product-description-dialog').css("top", scrollTop + "px");
    $('#supplier-product-description-dialog, #sitewide-overlay').fadeIn();
  }
}